import { render, staticRenderFns } from "./ClientSpaceImpersonateButton.vue?vue&type=template&id=2a9c2a7f"
import script from "./ClientSpaceImpersonateButton.vue?vue&type=script&lang=js"
export * from "./ClientSpaceImpersonateButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports